import { render, staticRenderFns } from "./moduleCenter.vue?vue&type=template&id=3a24bf59&scoped=true"
import script from "./moduleCenter.vue?vue&type=script&lang=js"
export * from "./moduleCenter.vue?vue&type=script&lang=js"
import style0 from "./moduleCenter.vue?vue&type=style&index=0&id=3a24bf59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a24bf59",
  null
  
)

export default component.exports